<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>

    <template #content>
      <article class="blog-content" lang="de">
        <section class="intro">
          <p>
            „Virtuelle Campus-Tour" war in diesem Monat ein BREAKOUT-Suchbegriff
            bei Google Trends – ein Signal, dass das Interesse an Virtual Tours
            für Bildungseinrichtungen auf einem Allzeithoch ist. Schulen,
            Hochschulen und Universitäten weltweit nutzen Virtual Tours, um
            Studenten zu gewinnen, Einrichtungen zu präsentieren und
            geografische Barrieren bei der Einschreibung zu beseitigen.
          </p>
        </section>

        <section>
          <h2>Warum Bildungseinrichtungen Virtual Tours brauchen</h2>
          <p>
            Angehende Studenten recherchieren Schulen zunehmend online, bevor
            sie persönlich vorbeischauen – oder statt eines Besuchs. Eine
            überzeugende virtuelle Campus-Tour kann der entscheidende Faktor für
            einen entfernten Bewerber sein, der zwischen zwei gleich platzierten
            Einrichtungen wählt. Universitäten, die Virtual Tours
            veröffentlichen, berichten von
            <strong>30–50 % höheren Tag-der-offenen-Tür-Registrierungen</strong>
            von Studenten außerhalb des Bundeslandes und aus dem Ausland.
          </p>
        </section>

        <section>
          <h2>
            Was Sie in einer Schul- oder Universitäts-Virtual-Tour aufnehmen
            sollten
          </h2>
          <p>
            Für eine vollständige virtuelle Campus-Tour erfassen Sie:
            Haupteingang und Empfang, Vorlesungssäle und Klassenräume, Labore
            und spezialisierte Einrichtungen, Studentengemeinschaftsbereiche und
            Mensa, Bibliothek, Sporteinrichtungen und Fitnessstudio,
            Studentenwohnheim, Außenbereiche und Gärten sowie die umliegende
            Nachbarschaft.
          </p>
        </section>

        <section>
          <h2>Wie Sie eine Schul-Virtual-Tour mit Travvir erstellen</h2>
          <h3>Route planen</h3>
          <p>
            Kartieren Sie den logischen Ablauf eines Besuchs potenzieller
            Studenten: Eingang → Empfang → akademische Bereiche → soziale
            Bereiche → Unterkunft. Dieses Aufnahmereihenfolge macht die Tour
            intuitiv navigierbar.
          </p>
          <h3>Jeden Bereich aufnehmen</h3>
          <p>
            Verwenden Sie die Travvir-App, um 360°-Fotos von jedem Bereich
            aufzunehmen. Für große Räume wie Vorlesungssäle nehmen Sie von
            mehreren Positionen auf, um Besuchern ein vollständiges Gefühl für
            die Größe zu geben. Für kleinere Räume wie Labore ist eine einzelne
            zentrale Aufnahme ausreichend.
          </p>
          <h3>Informations-Hotspots hinzufügen</h3>
          <p>
            Travvir ermöglicht das Hinzufügen von Text-Hotspots mit
            Einrichtungsinformationen – Klassengrößen, Gerätespezifikationen,
            Öffnungszeiten und Links zu Einschreibungsseiten. Diese
            Informationsebenen verwandeln eine visuelle Tour in einen
            interaktiven Studienführer.
          </p>
          <h3>In Ihrer Zulassungsseite einbetten</h3>
          <p>
            Betten Sie die fertige Tour direkt in Ihre Zulassungs- oder
            „Besuchen Sie uns"-Seite ein. Fügen Sie einen klaren CTA („Tag der
            offenen Tür buchen" oder „Jetzt bewerben") in der Nähe der Tour
            hinzu, um das hohe Engagement zu nutzen.
          </p>
        </section>

        <section>
          <h2>Vorteile für die Studentengewinnung</h2>
          <p>
            Virtual Tours reduzieren die Kosten pro eingeschriebenem Studenten,
            indem sie den Bedarf an teuren Tagen der offenen Tür für entfernte
            Bewerber beseitigen. Internationale Studenten – die nicht persönlich
            kommen können – verlassen sich fast ausschließlich auf digitale
            Ressourcen. Eine hochwertige virtuelle Campus-Tour ist eines der
            kosteneffektivsten Rekrutierungsinstrumente.
          </p>
        </section>

        <RelatedPosts
          :currentSlug="postData.slug"
          :currentCategories="postData.categories"
        />
      
        <section>
          <h2>Weiterlesen</h2>
          <ul>
            <li><a href="/blog/de/virtual-tour-kleinunternehmen">Virtual Tour Kleinunternehmen : Kunden gewinnen</a></li>
            <li><a href="/blog/de/virtual-tour-museen-galerien">Virtual Tour Museen & Galerien</a></li>
            <li><a href="/blog/de/google-business-virtual-tour">Google Business Virtual Tour : Anleitung</a></li>
            <li><a href="/blog/de/360-virtual-tour-website-einbetten">360°-Virtual-Tour in Website einbetten</a></li>
            <li><a href="/blog/de/virtual-tour-analysen">Virtual Tour Analysen : Besucher verstehen</a></li>
            <li><a href="/blog/de/virtual-tour-mit-smartphone-erstellen">Virtual Tour mit Smartphone erstellen</a></li>
          </ul>
        </section>

      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";

const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;

const postData = blogPostsData.find(
  (post) => post.slug === "virtual-tour-schulen-universitaeten",
);

useBlogSeo({
  title: "Virtual Tour Schulen & Universitäten [2026] | Travvir",
  description:
    "360°-Virtual-Tours für Schulen und Universitäten. Bewerber begeistern, Open-Days optimieren und Reichweite global erhöhen.",
  slug: "virtual-tour-schulen-universitaeten",
  image: postData?.image,
  postData,
  lang: "de",
});

</script>
